import "./Media.css";
import { useContext, useRef, useState, useEffect } from "react";
import { usePreference } from "../../../context/usePreference";
import blurPanel from "../../../utils/BlurPanel";
import { GetArrayDataCollectionList } from "../../../utils/arrayHelperList";
import { MediaTableRow } from "./MediaTableRow";
import { MediaTableRowFirst } from "./MediaTableRowFirst";
import { processAudienceMedia, validAudienceMedia } from "./MediaUtils";
import { ImageWithFallback } from "../Image/ImageWithFallback";
import { DivMinuteEnum, SelectTypeGridEnum } from '../../../utils/enums';
import { MediaGraphic } from "./MediaGraphic";
import { UiContext } from "../../../context/UiContext";
import { Left } from "react-bootstrap/lib/Media";

export function MediaTable({
  audienceMedia,
  audienceMediaFirstTable,
  heading,
  handleScroll,
  onSelectGridMinute,
  selectTypeGrid,
  dataPie,
  lastAudience,
  DivMinute,
  DivChart,
}) {
  const { isMobile, calculateEmissorasColumn, hasShortHeightDetail, hasShortHeight, mediaHeaderWidthAbsolute, mediaHeaderWidth2Absolute } = useContext(UiContext);
  const [heightPage, setHeightPage] = useState(window.innerHeight);

  const tableRightRef = useRef<HTMLDivElement>(null);

  function updateHeight() {
    setHeightPage(window.innerHeight);
  }
  let emissoraWidth = Math.round(calculateEmissorasColumn(heading?.enabled));

  const handleScrollMedia = (e) => {
    let divTableLeft = document.querySelector("#divTableMediaLeft")!;
    divTableLeft.scrollTop = divTableLeft != null ? e.currentTarget.scrollTop : 0;
    handleScroll(e);
  }

  const getDivChartHeight = (DivChart: number, isMobile: boolean): number => {

    const baseHeights = [
      document.querySelector("#MediaGraphic") != null ? document.querySelector("#MediaGraphic")!.clientHeight : 0,
      document.querySelector("#DivMedComp") != null ? document.querySelector("#DivMedComp")!.clientHeight : 0, 0,
      document.querySelector("#MediaGraphic") != null ? document.querySelector("#MediaGraphic")!.clientHeight : 0,
    ];

    let baseHeight = baseHeights[DivChart] || 0;
    return baseHeight;
  };

  const getHeightTableRight = () => {
    let barraSuperiorHeight = document.querySelector(".menu") != null ? document.querySelectorAll(".menu")[0].clientHeight : 0;
    let barraInfoHeight = document.querySelector(".divDate") != null ? document.querySelectorAll(".divDate")[0].clientHeight : 0;
     let barraBrand = document.querySelector("#divHeader") != null ? document.querySelectorAll("#divHeader")[0].clientHeight : 0;

    return window.innerHeight - getDivChartHeight(DivChart, isMobile) - barraSuperiorHeight - barraInfoHeight - barraBrand;
  }

  const u = usePreference();
  let colSpanSize: number = u.userPreference?.TipoBase === 0 ? 2 : 1;

  const Indice = u.userPreference?.Indice;

  let openSelectGrid = (event) => {
    blurPanel.setBlur(true);
    onSelectGridMinute(true);
  };
  window.addEventListener("resize", updateHeight);

  useEffect(() => {
    const resizeEvent = new Event("resize");
    setTimeout(() => {
      window.dispatchEvent(resizeEvent);
    }, 0);
  }, [audienceMedia, heading]);

  return (
    <div>
      <div className={
        (selectTypeGrid === SelectTypeGridEnum.Both || selectTypeGrid === SelectTypeGridEnum.Chart) && DivMinute === DivMinuteEnum.Media && !hasShortHeight
          ? "divExib"
          : "divExibHide"
      } style={{ width: "100%", display: "block" }}>
        <MediaGraphic
          heading={heading}
          lastAudience={lastAudience}
          data={audienceMedia}
          Indice={Indice}
          selectTypeGrid={selectTypeGrid}
          divMinute={DivMinute}
          audienceMediaFirstTable={audienceMediaFirstTable}
        />
      </div>
      <div className="divTablesMedia">

        <div
          id="divTableMediaLeft"
          data-testid="divTableMediaLeft"
          style={{
            width: mediaHeaderWidthAbsolute + "px",
            minWidth: mediaHeaderWidthAbsolute + "px",
            float: "left",
            overflow: "hidden",
            height: getHeightTableRight(),
            paddingBottom: "100px",
            backgroundColor: "#e8e8ee",
          }}
        >
          <table style={{
            width: (mediaHeaderWidthAbsolute) + "px",
            fontSize: isMobile ? "11px" : "",
            borderRight: "1px solid #000",
          }}>
            <thead>
              <tr>
                <th
                  colSpan={colSpanSize}
                  className="Media_headerFirst"
                  style={{
                    minWidth: "120px",
                    minHeight: isMobile ? "70px" : "60px",
                    height: isMobile ? "70px" : "60px",
                  }}
                >
                  <button className="buttonDet" onClick={openSelectGrid}>
                    {!isMobile ? (
                      <img
                        alt="icon_split_desktop"
                        src={require("../../../assets/custom/icons/icon_split_desktop.png")}
                        
                           style={{ height: hasShortHeightDetail ? "20px" : "30px" }}
                      />
                    ) : (
                      <img
                        alt="icon_split_desktop"
                        src={require("../../../assets/custom/icons/icon_split_mobile.png")}
                        style={{ height: "26px" }}
                      />
                    )}
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              {GetArrayDataCollectionList(audienceMediaFirstTable)?.map(
                (rowContent, index) => (
                  <MediaTableRowFirst
                    rowContent={rowContent.Data}
                    rowID={rowContent.dataID}
                    key={rowContent.dataID}
                  />
                )

              )}
            </tbody>
          </table>
        </div>

        <div
          id="divTableMediaRight"
          data-testid="divTableMediaRight"
          onScroll={handleScrollMedia}
          ref={tableRightRef}
          style={{
            width: mediaHeaderWidth2Absolute + "px",
            overflowX: "scroll",
            overflow: "auto",
            height: getHeightTableRight(),
            float: "left",
            paddingRight: window.innerWidth <= 120 ? '10px' : '0px',
            display: "block",
            marginLeft: "-2px",
            backgroundColor: "#e8e8ee",
          }}
        >
          <table style={{ position: 'sticky', top: '0', width: mediaHeaderWidth2Absolute, tableLayout: "auto" }}>
            <thead style={{ width: "100%" }}>
              <tr>
                {GetArrayDataCollectionList(heading?.enabled)?.map(
                  (head) => (
                    <th className="Media_tableHeader" key={head.dataID} style={
                      {
                        width: emissoraWidth,
                        minWidth: emissoraWidth,
                        minHeight: isMobile ? "70px" : "60px",
                        height: isMobile ? "70px" : "60px",
                      }
                    }>
                      <ImageWithFallback
                        key={head.Data.id}
                        title={head.Data.label}
                        src={head.Data.icons.table}
                        style={{
                          width: isMobile ? "30px" : "44px"
                        }}
                        dataid={head.Data.id}
                        className=''
                        showTitle={false}
                      />
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {GetArrayDataCollectionList(audienceMedia)?.map(
                (rowContent) => (
                  <MediaTableRow
                    audienceMediaFirstTable={audienceMediaFirstTable}
                    rowContent={rowContent.Data}
                    rowID={rowContent.dataID}
                    key={rowContent.dataID}
                  />
                )
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
